import Api from "@/lib/Api"

export const disconnect = (): Promise<void> =>  Api.get("/admn/disconnect/")
